import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { setupDxLicense } from '@svnxii/shared/configs/dx-license';
import { disableSorting } from '@svnxii/shared/configs/dx-config';

import { RouteLoadingService } from 'svnxii-modules/shared-service';
import { GlobalLoaderComponent } from 'svnxii-ng-shared/components/global-loader';
import { ToastContainerComponent } from 'svnxii-ng-shared/components/toast';

setupDxLicense();
disableSorting();
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastContainerComponent, GlobalLoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private routeLoadingService = inject(RouteLoadingService);
}
